export const IS_EXPERIENCED_OPTIONS = [
  {
    text: 'Yes',
    value: true,
  },
  {
    text: 'No',
    value: false,
  },
];

export const OBJECTIVES_OPTIONS = [
  {
    text: 'Diversification',
    value: 'Diversification',
  },
  {
    text: 'Inflation Hedge',
    value: 'Inflation Hedge',
  },
  {
    text: 'Passive Income',
    value: 'Passive Income',
  },
  {
    text: 'Capital Appreciation',
    value: 'Capital Appreciation',
  },
  {
    text: 'Non-correlated Assets',
    value: 'Non-correlated Assets',
  },
];

export const RISK_TOLERANCE_OPTIONS = [
  {
    text: 'Risk Averse — I could not withstand the potential loss of principal. ',
    value: 'averse',
    messageIcon: 'exclamation',
    message: 'Our Platform is more suitable for investors who are willing and able to absorb the risks associated with the loss of their investment.',
  },
  {
    text: 'Risk Neutral — Preference to avoid risk, but tolerant to achieve investment objectives.',
    value: 'neutral',
  },
  {
    text: 'Risk Tolerant — Greater tolerance for risk with the objective to increase returns.',
    value: 'tolerant',
  },
];

export const TIME_HORIZON_OPTIONS = [
  {
    text: 'Short Term (1-3 years)',
    value: 'short',
    messageIcon: 'exclamation',
    message: 'Investments on our Platform are designed to have an intermediate to long term investment holding period of at least 3 years or more.',
  },
  {
    text: 'Intermediate Term (3-10 years)',
    value: 'intermediate',
  },
  {
    text: 'Long Term (10+ years)',
    value: 'long',
  },
];

export const WEALTH_OPTIONS = [
  {
    text: 'Compensation',
    value: 'Compensation',
  },
  {
    text: 'Real Estate',
    value: 'Real Estate',
  },
  {
    text: 'Inheritance',
    value: 'Inheritance',
  },
  {
    text: 'Business Owner',
    value: 'Business Owner',
  },
  {
    text: 'Investments',
    value: 'Investments',
  },
  {
    text: 'Retirement Savings',
    value: 'Retirement Savings',
  },
];

export const EMPLOYMENT_STATUS_OPTIONS = [
  {
    text: 'Employed',
    value: 'Employed',
  },
  {
    text: 'Self-Employed',
    value: 'Self-Employed',
  },
  {
    text: 'Unemployed',
    value: 'Unemployed',
  },
  {
    text: 'Retired',
    value: 'Retired',
  },
];

export const IS_REGULATOR_OPTIONS = [
  {
    text: 'Yes',
    value: true,
    messageIcon: 'exclamation',
    message: 'As an Employee of a FINRA/Exchange member Broker-Dealer or a Financial Regulator AcreTrader will need you to provide a letter from your employer to allow you to invest on our platform. A notification will be sent to your email.',
  },
  {
    text: 'No',
    value: false,
  },
];
